import React, { useState } from "react";
import { Button, Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from '@mui/icons-material/Add';
import BookIcon from '@mui/icons-material/Book';
import EventIcon from '@mui/icons-material/Event';

import ShiftNotesForm from "../components/ShiftNotesForm";

const ShiftsRequestsButton: React.FC = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const iconStyle = {
    fontSize: '5rem', // Adjust the size as needed
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
      transform: 'scale(1.2)', // Adjust the zoom level as needed
    },
  };


  
  return (
    <div>
      <Button
        sx={{
          bgcolor: 'var(--color-ocean-default)',
          color: 'var(--color-offwhite)',
          py: '20px',
          ':hover': {
            bgcolor: 'var(--color-ocean-highlight)',
            color: 'var(--color-dark-gray)'
          },
          height: '130px',
          maxWidth: '358px',
          mr: 2,
          flexDirection: 'column', // Align content vertically
          gap: 1 // Add some space between icon and text
        }}
        fullWidth
        size="large"
        variant="contained"
        startIcon={<EventIcon sx={{mr:'10px'}} style={iconStyle}/>}
        onClick={() => setOpen(true)}
      >
        Shifts Request
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md" fullScreen PaperProps={{ style: { backgroundColor: 'transparent', boxShadow: 'none' , marginTop:'180px', marginRight:'150px'} }}>
        <IconButton
          sx={{
            position: "absolute",
            top: "8px",
            right: "8px",
            color: "grey.600",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.1)",
            },
          }}
          onClick={handleClose}
          aria-label="close"
        >
          <CloseIcon
            sx={{
              border: "2px solid #ff7f7f", // Light red border
              borderRadius: "4px", // Adjust border radius as needed
              padding: "4px", // Adjust padding as needed
            }}
          />
        </IconButton>
        <DialogContent sx={{marginTop:'100px'}}>
          <ShiftNotesForm />
          {/* <Timesheets/> */}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ShiftsRequestsButton;
